var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimePatternIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 26.7747L12 15V50.5H1V26.7747Z",
    fill: "#8CBFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3203 32.2392L47.999 7V50.5H28.3203V32.2392Z",
    fill: "#8CBFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 32.5L12 15V50.5H28.5V32.5Z",
    fill: "#3B82C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8528 3.85714L28.4414 32.5361L11.9637 15.509L1 26.7747V24.589L1.10737 20.3946L11.9637 9.28913L28.1639 25.9634L48.4664 1.09277L51.8528 3.85714Z",
    fill: "#2B6299"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0V50.7955H51.7955",
    stroke: "#B3B3B3",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimePatternIcon);
export default __webpack_public_path__ + "static/media/time_pattern_icon.d77e0308.svg";
export { ForwardRef as ReactComponent };